/**
 * MM Smart Search — fuzzy matching (EN/AR, typos, synonyms)
 */
(function (global) {
  'use strict';

  var TOKEN_SYNONYMS = {
    protein: ['protien', 'proten', 'protin', 'whey', 'casein', 'isolate', 'بروتين', 'بروتیين', 'واي', 'بروتينات'],
    whey: ['protein', 'way', 'واي', 'وائي', 'whey isolate', 'isolate'],
    creatine: ['kreatine', 'creatin', 'كرياتين', 'كراتين', 'monohydrate'],
    preworkout: ['pre-workout', 'pre workout', 'preworkot', 'بري ورك', 'قبل التمرين', 'تمرين', 'workout'],
    workout: ['preworkout', 'pre-workout', 'training', 'تمرين', 'تمارين'],
    gainer: ['mass', 'mass-gainer', 'bulk', 'وزن', 'تضخيم', 'mass gainer'],
    vitamin: ['vitamins', 'multi', 'فيتامين', 'فيتامينات', 'multivitamin'],
    fat: ['burner', 'burn', 'cutting', 'حرق', 'دايت', 'weight loss', 'fat loss'],
    snack: ['snacks', 'bar', 'bars', 'سناك', 'سناكات', 'بار'],
    brand: ['brands', 'علامة', 'علامات', 'ماركة', 'ماركات'],
    amino: ['amino', 'eaa', 'bcaa', 'aminos', 'أحماض', 'امينو'],
    omega: ['fish oil', 'oils', 'أوميغا', 'زيت السمك'],
    sleep: ['recovery', 'rest', 'نوم', 'راحة', 'استشفاء'],
    joint: ['bone', 'ligament', 'مفاصل', 'عظام'],
    shaker: ['bottle', 'mixer', 'shakers', 'خلاط', 'زجاجة'],
    applied: ['applied nutrition', 'ابلايد', 'أبلايد'],
    muscletech: ['muscle tech', 'ماسل تك'],
    bolero: ['بوليرو'],
    bombbar: ['بومبار'],
    energy: ['endurance', 'طاقة', 'تحمل'],
    carb: ['carbs', 'carbohydrate', 'كرب', 'كربوهيدرات'],
    health: ['immunity', 'general health', 'صحة', 'مناعة']
  };

  function normalize(str) {
    if (!str) return '';
    return String(str)
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[أإآٱ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/[^\w\s\u0600-\u06FF]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokenize(str) {
    var n = normalize(str);
    if (!n) return [];
    return n.split(' ').filter(function (t) {
      return t.length > 0;
    });
  }

  function levenshtein(a, b, maxDist) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    var la = a.length;
    var lb = b.length;
    if (typeof maxDist === 'number' && Math.abs(la - lb) > maxDist) return maxDist + 1;
    var row = [];
    var i;
    var j;
    for (j = 0; j <= lb; j++) row[j] = j;
    for (i = 1; i <= la; i++) {
      var prev = i - 1;
      row[0] = i;
      var minRow = row[0];
      for (j = 1; j <= lb; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var val = Math.min(row[j] + 1, row[j - 1] + 1, prev + cost);
        prev = row[j];
        row[j] = val;
        if (val < minRow) minRow = val;
      }
      if (typeof maxDist === 'number' && minRow > maxDist) return maxDist + 1;
    }
    return row[lb];
  }

  function maxEditDistance(len) {
    if (len <= 3) return 1;
    if (len <= 6) return 2;
    return 3;
  }

  function expandToken(token) {
    var out = {};
    out[token] = true;
    var folded = token.replace(/-/g, '');
    if (folded !== token) out[folded] = true;
    Object.keys(TOKEN_SYNONYMS).forEach(function (key) {
      var syns = TOKEN_SYNONYMS[key];
      var keyNorm = normalize(key);
      var related =
        keyNorm === token ||
        syns.some(function (s) {
          return normalize(s) === token;
        });
      if (related) {
        out[keyNorm] = true;
        syns.forEach(function (s) {
          var ns = normalize(s);
          if (ns) out[ns] = true;
        });
      }
    });
    return Object.keys(out);
  }

  function fuzzyTokenMatch(queryToken, haystack, hayTokens) {
    if (!queryToken || queryToken.length < 2) return true;
    if (haystack.indexOf(queryToken) !== -1) return true;
    var maxDist = maxEditDistance(queryToken.length);
    var i;
    for (i = 0; i < hayTokens.length; i++) {
      var h = hayTokens[i];
      if (!h || h.length < 2) continue;
      if (h.indexOf(queryToken) !== -1 || queryToken.indexOf(h) !== -1) return true;
      if (h.length >= 3 && queryToken.length >= 3) {
        if (levenshtein(queryToken, h, maxDist) <= maxDist) return true;
        if (queryToken.length >= 3 && h.length >= queryToken.length) {
          if (levenshtein(queryToken, h.slice(0, queryToken.length), maxDist) <= maxDist) return true;
        }
      }
    }
    if (queryToken.length >= 3) {
      for (i = 0; i < haystack.length - queryToken.length + 1; i++) {
        var slice = haystack.slice(i, i + queryToken.length);
        if (levenshtein(queryToken, slice, maxDist) <= maxDist) return true;
      }
    }
    return false;
  }

  function matchesFuzzySearch(query, haystack) {
    var q = normalize(query);
    if (!q) return true;
    var hay = normalize(haystack);
    if (!hay) return false;
    if (hay.indexOf(q) !== -1) return true;
    var qTokens = tokenize(q);
    if (!qTokens.length) return true;
    var hayTokens = tokenize(hay);
    return qTokens.every(function (rawToken) {
      var variants = expandToken(rawToken);
      return variants.some(function (token) {
        return fuzzyTokenMatch(token, hay, hayTokens);
      });
    });
  }

  function productHaystack(product) {
    if (!product) return '';
    return [
      product.title,
      product.titleLower,
      product.brand,
      product.brandLower,
      product.handle,
      (product.handle || '').replace(/-/g, ' ')
    ].join(' ');
  }

  global.MMSmartSearch = {
    normalize: normalize,
    tokenize: tokenize,
    matchesFuzzySearch: matchesFuzzySearch,
    productHaystack: productHaystack,
    levenshtein: levenshtein
  };
})(typeof window !== 'undefined' ? window : globalThis);
